import { render, staticRenderFns } from "./DockButton.vue?vue&type=template&id=4872064a&scoped=true"
import script from "./DockButton.vue?vue&type=script&lang=js"
export * from "./DockButton.vue?vue&type=script&lang=js"
import style0 from "./DockButton.vue?vue&type=style&index=0&id=4872064a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4872064a",
  null
  
)

export default component.exports